// @ts-nocheck -- TypeScript migration in progress: bulk-renamed from .js and not
// yet typed. Remove this directive and add real types when converting this
// module. Backlog: grep -rl "@ts-nocheck" src. See docs/typescript-migration.md.
import { propellerRpmEvidenceRows } from "../findings/propeller-rpm-evidence.js";
import {
  findingCausePresentation,
  reportActionText,
  reportFindingEvidenceLine,
} from "../findings/presentation.js";
import { fuelPressureEvidenceRows } from "../findings/fuel-pressure-evidence.js";

export function writeFuelPressureContextSection(writer, summary) {
  const metric = summary?.fuelPressure;
  if (!metric) return;
  writer.heading("Fuel Pressure Context");
  writer.paragraph(`${metric.status}: ${metric.note}`);
  writer.paragraph("Advisory context only. Fuel-pressure observations do not affect the health score.");
  for (const engine of metric.details?.engines ?? []) {
    writer.keyValue(`${engine.label} coverage`, `${engine.status}; ${engine.recordedSampleCount} recorded samples; ${engine.analyzedDurationSeconds ?? 0} sec eligible`);
    for (const reason of engine.reasons ?? []) writer.paragraph(reason);
  }
  for (const event of metric.details?.events ?? []) {
    writer.heading(event.label);
    writer.keyValue("Engine", event.engineLabel);
    writer.keyValue("Window", `${event.startTime} to ${event.endTime} sec elapsed (${event.phase})`);
    for (const [label, value] of fuelPressureEvidenceRows(event)) writer.keyValue(label, value);
    writer.paragraph(event.interpretationHint);
  }
  if (metric.details?.omittedEventCount) writer.paragraph(`${metric.details.omittedEventCount} additional observations omitted from the retained event list.`);
}

export function writePrimaryFindingSections(writer, { finding, primaryMetric } = {}) {
  const activeFinding = finding ?? {};
  writer.heading("Primary Finding");
  writer.keyValue("Finding", activeFinding.title);
  writer.keyValue("Evidence", reportFindingEvidenceLine(activeFinding, primaryMetric?.note ?? ""));
  writer.paragraph(activeFinding.body);
  writer.keyValue("Confidence", activeFinding.confidence);

  const causePresentation = findingCausePresentation(activeFinding, primaryMetric);
  writer.heading(causePresentation.title);
  (activeFinding.causes ?? []).forEach(([cause, probability]) => {
    writer.bullet(causePresentation.weighted
      ? `${cause} (${Math.round((probability ?? 0) * 100)}%)`
      : cause);
  });

  writer.heading("Suggested Review");
  (activeFinding.actions ?? []).forEach(([priority, action]) => {
    writer.bullet(reportActionText(priority, action));
  });
}

export function writePropellerRpmContextSection(writer, summary = {}) {
  const metric = summary.propellerRpm;
  if (!metric) return;
  writer.heading("Propeller RPM");
  writer.paragraph("Advisory context only. These observations do not affect the health score or establish a governor or propeller fault.");
  writer.paragraph(metric.note);
  const details = metric.details ?? {};
  for (const engine of details.engines ?? []) {
    const coverage = Number.isFinite(engine.analyzedDurationSeconds) ? `; ${Math.round(engine.analyzedDurationSeconds)} sec supported` : "";
    writer.keyValue(`${engine.label ?? "Engine"} coverage`, `${engine.status ?? "unavailable"}${coverage}`);
    for (const reason of engine.reasons ?? []) writer.paragraph(reason);
  }
  for (const event of details.events ?? []) {
    writer.heading(event.label ?? "RPM observation");
    if (event.phase) writer.keyValue("Flight phase", event.phase);
    writer.paragraph(event.interpretationHint);
    for (const [label, value] of propellerRpmEvidenceRows(event)) writer.keyValue(label, value);
  }
  if (details.omittedEventCount > 0) writer.paragraph(`${details.omittedEventCount} additional observations omitted from the retained evidence.`);
  for (const limitation of details.limitations ?? []) writer.paragraph(limitation);
}
